import React from 'react'
import IconHelper from '@ringdna/common/src/assets/icons/IconHelper'
import TeamIcon from '@ringdna/common/src/assets/icons/svg/Team'
import { Colors } from '@ringdna/common/src/constants/colors'
import UsersIcon from '@ringdna/common/src/assets/icons/svg/Users'
import SalesforceProfileIcon from '@ringdna/common/src/assets/icons/svg/SalesforceProfile'
import SalesforceRoleIcon from '@ringdna/common/src/assets/icons/svg/SalesforceRole'
import { AlertsTargetingType } from '@ringdna/common/src/types/moments'
import RdnaTooltip from '@ringdna/common/src/components/RdnaTooltip'
import ConditionalWrapper from '@ringdna/common/src/utils/conditionalWrapper'
import styled from 'styled-components'

const getIcon = (type?: string | null) => {
  switch (type) {
    case AlertsTargetingType.ALL_USERS:
      return UsersIcon
    case AlertsTargetingType.SALESFORCE_PROFILES:
      return SalesforceProfileIcon
    case AlertsTargetingType.SALESFORCE_ROLES:
      return SalesforceRoleIcon
    case AlertsTargetingType.TEAMS:
      return TeamIcon
    default:
      return null
  }
}

const TargetingIcon = ({ type, labelType }: { type?: string | null; labelType: 'tooltip' | 'text' }) => {
  const Icon = getIcon(type)
  const label = (type || '').split(/(?=[A-Z])/).join(' ')
  return Icon ? (
    <ConditionalWrapper
      condition={labelType === 'tooltip'}
      wrapper={children => <RdnaTooltip title={label}>{children}</RdnaTooltip>}
    >
      <IconContainer>
        <IconHelper icon={Icon} variant={'outlined'} title={label} color={Colors.BLACK} />
        {labelType === 'text' && <span>{label}</span>}
      </IconContainer>
    </ConditionalWrapper>
  ) : (
    <div></div>
  )
}

export default TargetingIcon

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing}px;
`
